import { render, staticRenderFns } from "./PedidosComprar.vue?vue&type=template&id=72c9e8ac&scoped=true&lang=pug"
import script from "./PedidosComprar.vue?vue&type=script&lang=js"
export * from "./PedidosComprar.vue?vue&type=script&lang=js"
import style0 from "./PedidosComprar.vue?vue&type=style&index=0&id=72c9e8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c9e8ac",
  null
  
)

export default component.exports